import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Dashboard from "../../pages/Dashboard";
import ProductHistory from "./ProductHistory";
import ManageProducts from "./ManageProducts";
import BillingHistory from "./BilingHistory";
import Transactions from "./Transactions";
import SaleBySeller from "./SaleBySeller";
import TrackingPage from "./orders";
import SavedProducts from "../savedProduct";

const SellerPage = () => {
  const [currentPage, setCurrentPage] = useState("Home");
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen">
      <Sidebar
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />
      <div className="flex-1 overflow-auto max-h-screen">
        <Header
          currentPage={currentPage}
          setCollapsed={setCollapsed}
          collapsed={collapsed}
        />
        <div>
          {currentPage === "Home" && <Dashboard />}
          {currentPage === "Product History" && <ProductHistory />}
          {currentPage === "Add Product" && <ManageProducts />}
          {currentPage === "Billing History" && <BillingHistory />}
          {currentPage === "Transactions" && <Transactions />}
          {currentPage === "Sale by Seller" && <SaleBySeller />}
          {currentPage === "Saved Products" && <SavedProducts />}
          {currentPage === "Order" && <TrackingPage />}
        </div>
      </div>
    </div>
  );
};

export default SellerPage;
